import { Badge, Field, TextInput } from "@nabble/ui";
import type { AllowedRange } from "./policyValues";
import type { PolicyField } from "./policySections";

interface PolicyFieldRowProps {
  field: PolicyField;
  value: string;
  defaultValue: number;
  /** Why the value typed isn't accepted, checked here before asking the server. */
  invalid: string | undefined;
  /** The range the server accepts, when it refused the value. */
  range: AllowedRange | undefined;
  onChange: (value: string) => void;
}

/** One policy: what it means, whether it differs from the default, and its numeric input. */
export function PolicyFieldRow({ field: f, value, defaultValue, invalid, range, onChange }: PolicyFieldRowProps): React.JSX.Element {
  const changed = value !== String(defaultValue);
  return (
    <div className="nb-setting-row">
      <div>
        <div className="nb-setting-title">
          {f.label} {changed ? <Badge label="Customized" tone="info" dot={false} /> : null}
        </div>
        <p className="nb-setting-desc">{f.description}</p>
      </div>
      <div className="nb-setting-content" style={{ maxWidth: 320 }}>
        <Field
          hideLabel
          label={`${f.label} (${f.unit})`}
          error={invalid ?? (range ? `It must be between ${range.min} and ${range.max}.` : undefined)}
          help={`Default value: ${defaultValue} ${f.unit}`}
        >
          <TextInput inputMode="numeric" suffix={f.unit} value={value} onChange={(e) => onChange(e.target.value)} />
        </Field>
      </div>
    </div>
  );
}
